import React from 'react';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import { CommonHash } from 'app/types';

interface CompProps {
  data: CommonHash[];
  columns: any[];
  filters?: any[];
  defaultSort?: any;
  total: number;
  limit: number;
  setLimit: (limit: number) => void;
  page: number;
  setPage: (page: number) => void;
  setFilterValue?: (hash: any) => void;
}

const NewTable = ({
  data,
  columns,
  filters,
  defaultSort,
  total,
  limit,
  setLimit,
  page,
  setPage,
  setFilterValue,
}: CompProps): React.ReactElement => {
  const gridStyle = { minHeight: 550 };
  const calculateNewPage = (skip: number) => {
    setPage(Math.floor(skip / limit) + 1);
  };

  const handleLimitChange = (newLimit: number) => {
    setPage(Math.floor((page * limit) / newLimit) + 1);
    setLimit(newLimit);
  };
  return (
    <ReactDataGrid
      idProperty="id"
      style={gridStyle}
      columns={columns}
      rowHeight={30}
      dataSource={Promise.resolve({ data, count: total || 0 })}
      pagination="remote"
      limit={limit}
      onLimitChange={(e) => handleLimitChange(e)}
      defaultFilterValue={filters}
      defaultSortInfo={defaultSort}
      onSkipChange={(e) => calculateNewPage(e)}
      onFilterValueChange={setFilterValue}
    />
  );
};

export default NewTable;
